"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.renderAutoComplete = void 0;
var solid_logic_1 = require("solid-logic");
var solid_ui_1 = require("solid-ui");
var publicData_1 = require("./publicData");
var AUTOCOMPLETE_THRESHOLD = 4; // don't check until this many characters typed
var AUTOCOMPLETE_ROWS = 20; // 20?
var AUTOCOMPLETE_ROWS_STRETCH = 40;
var AUTOCOMPLETE_DEBOUNCE_MS = 300;
var autocompleteRowStyle = 'border: 0.2em solid straw;'; // @@ white
// The core of the autocomplete UI
function renderAutoComplete(dom, options, // subject:NamedNode, predicate:NamedNode,
callback) {
    return __awaiter(this, void 0, void 0, function () {
        function complain(message) {
            var errorRow = table.appendChild(dom.createElement('tr'));
            console.log(message);
            errorRow.appendChild(solid_ui_1.widgets.errorMessageBlock(dom, message, 'pink'));
            solid_ui_1.style.setStyle(errorRow, 'autocompleteRowStyle');
            errorRow.style.padding = '1em';
        }
        function remove(ele) {
            if (ele) {
                ele.parentNode.removeChild(ele);
            }
        }
        function finish(object, name) {
            console.log('Auto complete: finish! ' + object);
            // remove(options.cancelButton)
            // remove(options.acceptButton)
            // remove(div)
            callback(object, name);
        }
        function gotIt(object, name) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (options.acceptButton) {
                        options.acceptButton.disabled = false;
                        searchInput.value = name; // complete it
                        foundName = name;
                        foundObject = object;
                        console.log('Auto complete: name: ' + name);
                        console.log('Auto complete: waiting for accept ' + object);
                        return [2 /*return*/];
                    }
                    finish(object, name);
                    return [2 /*return*/];
                });
            });
        }
        function acceptButtonHandler(_event) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (searchInput.value === foundName) { // still
                        finish(foundObject, foundName);
                    }
                    else {
                        options.acceptButton.disabled = true;
                    }
                    return [2 /*return*/];
                });
            });
        }
        function cancelButtonHandler(_event) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    console.log('Auto complete: Canceled by user! ');
                    div.innerHTML = ''; // Clear out the table
                    return [2 /*return*/];
                });
            });
        }
        function nameMatch(filter, candidate) {
            var parts = filter.split(' '); // Each name part must be somewhere
            for (var j = 0; j < parts.length; j++) {
                var word = parts[j];
                if (candidate.toLowerCase().indexOf(word) < 0)
                    return false;
            }
            return true;
        }
        function cancelText(_event) {
            searchInput.value = '';
            if (options.acceptButton) {
                options.acceptButton.disabled == true; // start again
            }
            candidatesLoaded = false;
        }
        function thinOut(filter) {
            var hits = 0;
            var pick = null, pickedName = '';
            for (var j = table.children.length - 1; j > 0; j--) { // backwards as we are removing rows
                var row = table.children[j];
                if (nameMatch(filter, row.textContent)) {
                    hits += 1;
                    pick = row.getAttribute('subject');
                    pickedName = row.textContent;
                    row.style.display = '';
                    row.style.color = 'blue'; // @@ chose color
                }
                else {
                    ;
                    row.style.display = 'none';
                }
            }
            if (hits == 1) { // Maybe require green confirmation button be clicked?
                console.log("  auto complete elimination:  \"".concat(filter, "\" -> \"").concat(pickedName, "\""));
                gotIt(solid_logic_1.store.sym(pick), pickedName); // uri, name
            }
        }
        function clearList() {
            while (table.children.length > 1) {
                table.removeChild(table.lastChild);
            }
        }
        function inputEventHHandler(_event) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (runningTimeout) {
                        clearTimeout(runningTimeout);
                    }
                    setTimeout(refreshList, AUTOCOMPLETE_DEBOUNCE_MS);
                    return [2 /*return*/];
                });
            });
        }
        function refreshList() {
            return __awaiter(this, void 0, void 0, function () {
                var languagePrefs, filter, bindings, err_1, loadedEnough, slimmed;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (inputEventHandlerLock) {
                                console.log("Ignoring \"".concat(searchInput.value, "\" because of lock "));
                                return [2 /*return*/];
                            }
                            inputEventHandlerLock = true;
                            return [4 /*yield*/, (0, publicData_1.getPreferredLanguages)()];
                        case 1:
                            languagePrefs = _a.sent();
                            filter = searchInput.value.trim().toLowerCase();
                            if (!(filter.length < AUTOCOMPLETE_THRESHOLD)) return [3 /*break*/, 2];
                            clearList();
                            candidatesLoaded = false;
                            numberOfRows = AUTOCOMPLETE_ROWS;
                            return [3 /*break*/, 7];
                        case 2:
                            if (allDisplayed && lastFilter && filter.startsWith(lastFilter)) {
                                thinOut(filter); // reversible?
                                inputEventHandlerLock = false;
                                return [2 /*return*/];
                            }
                            _a.label = 3;
                        case 3:
                            _a.trys.push([3, 5, , 6]);
                            return [4 /*yield*/, (0, publicData_1.queryPublicDataByName)(filter, OrgClass, options.queryParams)
                                // bindings = await queryDbpedia(sparql)
                            ];
                        case 4:
                            bindings = _a.sent();
                            return [3 /*break*/, 6];
                        case 5:
                            err_1 = _a.sent();
                            complain('Error querying db of organizations: ' + err_1);
                            inputEventHandlerLock = false;
                            return [2 /*return*/];
                        case 6:
                            candidatesLoaded = true;
                            loadedEnough = bindings.length < publicData_1.AUTOCOMPLETE_LIMIT;
                            if (loadedEnough) {
                                lastFilter = filter;
                            }
                            else {
                                lastFilter = null;
                            }
                            clearList();
                            slimmed = (0, publicData_1.filterByLanguage)(bindings, languagePrefs);
                            if (loadedEnough && slimmed.length <= AUTOCOMPLETE_ROWS_STRETCH) {
                                numberOfRows = slimmed.length; // stretch if it means we get all items
                            }
                            allDisplayed = loadedEnough && slimmed.length <= numberOfRows;
                            console.log(" Filter:\"".concat(filter, "\" bindings: ").concat(bindings.length, ", slimmed to ").concat(slimmed.length, "; rows: ").concat(numberOfRows, ", Enough? ").concat(loadedEnough, ", All displayed? ").concat(allDisplayed));
                            slimmed.slice(0, numberOfRows).forEach(function (binding) {
                                var row = table.appendChild(dom.createElement('tr'));
                                solid_ui_1.style.setStyle(row, 'autocompleteRowStyle');
                                var uri = binding.subject.value;
                                var name = binding.name.value;
                                row.setAttribute('style', 'padding: 0.3em;');
                                row.setAttribute('subject', uri);
                                row.style.color = allDisplayed ? '#080' : '#000'; // green means 'you should find it here'
                                row.textContent = name;
                                row.addEventListener('click', function (_event) { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        console.log('       click row textContent: ' + row.textContent);
                                        console.log('       click name: ' + name);
                                        gotIt(solid_logic_1.store.sym(uri), name);
                                        return [2 /*return*/];
                                    });
                                }); });
                            });
                            _a.label = 7;
                        case 7:
                            inputEventHandlerLock = false;
                            return [2 /*return*/];
                    }
                });
            });
        } // refreshList
        /* sparqlForSearch
        *
        * name -- e.g., "mass"
        * theType -- e.g., <http://umbel.org/umbel/rc/EducationalOrganization>
        */
        function sparqlForSearch(name, theType) {
            var clean = name.replace(/\W/g, ''); // Remove non alphanum so as to protect regexp
            var sparql = "select distinct ?subject, ?name where {\n      ?subject a <".concat(theType.uri, ">; rdfs:label ?name\n      FILTER regex(?name, \"").concat(clean, "\", \"i\")\n    } LIMIT ").concat(publicData_1.AUTOCOMPLETE_LIMIT);
            return sparql;
        }
        var queryParams, OrgClass, candidatesLoaded, runningTimeout, inputEventHandlerLock, allDisplayed, lastFilter, numberOfRows, div, foundName, foundObject, table, head, cell, searchInput, searchInputStyle;
        return __generator(this, function (_a) {
            queryParams = options.queryParams;
            OrgClass = options["class"] // kb.sym('http://umbel.org/umbel/rc/EducationalOrganization') // @@@ other
            ;
            if (options.acceptButton) {
                options.acceptButton.addEventListener('click', acceptButtonHandler, false);
            }
            if (options.cancelButton) {
                // options.cancelButton.addEventListener('click', cancelButtonHandler, false)
            }
            candidatesLoaded = false;
            runningTimeout = null;
            inputEventHandlerLock = false;
            allDisplayed = false;
            lastFilter = null;
            numberOfRows = AUTOCOMPLETE_ROWS;
            div = dom.createElement('div');
            foundName = null // once found accepted string must match this
            ;
            foundObject = null;
            table = div.appendChild(dom.createElement('table'));
            table.setAttribute('style', 'max-width: 30em; margin: 0.5em;');
            head = table.appendChild(dom.createElement('tr'));
            solid_ui_1.style.setStyle(head, 'autocompleteRowStyle');
            cell = head.appendChild(dom.createElement('td'));
            searchInput = cell.appendChild(dom.createElement('input'));
            searchInput.setAttribute('type', 'text');
            searchInputStyle = solid_ui_1.style.searchInputStyle ||
                'border: 0.1em solid #444; border-radius: 0.5em; width: 100%; font-size: 100%; padding: 0.1em 0.6em' // @
            ;
            searchInput.setAttribute('style', searchInputStyle);
            searchInput.addEventListener('keyup', function (event) {
                if (event.keyCode === 13) {
                    acceptButtonHandler(event);
                }
            }, false);
            searchInput.addEventListener('input', inputEventHHandler);
            return [2 /*return*/, div];
        });
    });
} // renderAutoComplete
exports.renderAutoComplete = renderAutoComplete;
var ends = 'ENDS';
